import React from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { cn } from '@/lib/utils';

export const getClientDetailsPath = (
  clientId: string | number | null | undefined,
  section = 'overview',
): string => {
  const normalizedClientId = String(clientId ?? '').trim();
  if (!normalizedClientId) return '/clients';
  const normalizedSection = String(section || 'overview').replace(/^\/+/, '');
  return `/clients/${encodeURIComponent(normalizedClientId)}/details-v2/${normalizedSection}`;
};

type ClientNameLinkProps = Omit<LinkProps, 'to'> & {
  clientId?: string | number | null;
  section?: string;
  to?: LinkProps['to'];
  stopPropagation?: boolean;
};

export const ClientNameLink: React.FC<ClientNameLinkProps> = ({
  clientId,
  section = 'overview',
  to,
  stopPropagation = true,
  className,
  children,
  onClick,
  ...props
}) => {
  const normalizedClientId = String(clientId ?? '').trim();
  const target = to ?? (normalizedClientId ? getClientDetailsPath(normalizedClientId, section) : null);

  if (!target) {
    return (
      <span className={className}>
        {children}
      </span>
    );
  }

  return (
        <Link
          to={target}
          className={cn(
            'underline-offset-2 transition-colors hover:underline focus-visible:underline focus-visible:outline-none',
            className,
          )}
      onClick={(event) => {
        if (stopPropagation) {
          event.stopPropagation();
        }
        onClick?.(event);
      }}
      {...props}
    >
      {children}
    </Link>
  );
};
